import { z } from "zod";
import { Exporter } from "../export/exporter";
import { Pipeline } from "../export/pipeline";

export const ExportJobDump = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  finishedAt: z.coerce.date(),
  exportArtefacts: z.string(),
});

export const CodeIntegrationDump = z.object({
  exporters: Exporter.array(),
  pipelines: Pipeline.array(),
  exportJobs: ExportJobDump.array(),
});

export type ExportJobDump = z.infer<typeof ExportJobDump>;
export type CodeIntegrationDump = z.infer<typeof CodeIntegrationDump>;
